import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ErrorIcon from '@wix/da-ds/pkg/Icons/16x16/ModerationAlert';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import s from './ErrorPostfix.scss';
/**
 * A button with an error icon inside and an appropriate tooltip. Will call the supplied {@link Props.onRetry|onRetry} function on click.
 */ const ErrorPostfix = ({ onRetry })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('estimatedEarnings.error.tooltip')
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, t('estimatedEarnings.error.a11y.context')), /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        icon: ErrorIcon,
        className: s['error-icon'],
        "aria-label": t('estimatedEarnings.error.a11y.buttonLabel'),
        onClick: onRetry
    }));
};
ErrorPostfix.displayName = 'ErrorPostfix';
export default ErrorPostfix;
